import { render, staticRenderFns } from "./canalesConsulta.vue?vue&type=template&id=8fb1e744"
import script from "./canalesConsulta.vue?vue&type=script&lang=js"
export * from "./canalesConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports